module.exports = __webpack_public_path__ + "fonts/MullerBoldItalic.a2ebf3d4.ttf";